<div class="card pt-4 noprint justify-content-center" *ngIf="activeStudent">
	<div class="text-center">
<div>


			<h5 class="card-title">
				 {{ activeStudent?.fname }} {{ activeStudent?.lname }}
			</h5>
			<h6 class="card-subtitle mb-2 text-muted">
				 {{ currentTestSystem.name }}
			</h6>
			<p class="card-text">
				  D.O.B: {{ activeStudent?.dob }}
			</p>
			<p class="card-text">
				 {{ activeStudent?.sex }}
			</p>


</div>
		<ng-template #popContent
			><h5 class="pb-0 text-center">
		<p *ngIf="!showLastPhase">		<i
			class="fa fa-check-circle"
			style="color: green; padding-right: 10px"
			aria-hidden="true"
		></i
		> This student has completed this Phase!</p>
				<p *ngIf="showLastPhase">		<i
					class="fa fa-check-circle"
					style="color: green; padding-right: 10px"
					aria-hidden="true"
				></i
				> This child has completed the last Phase. Congratulations!</p><br />
			</h5>
			<div class="text-center mb-1" *ngIf="!showLastPhase">
				Select the next Phase from the dropdown menu to continue.
			</div>
			<button
				class="btn btn-secondary btn-sm btn-block"
				(click)="popover.close()"
			>
				OK
			</button></ng-template
		>
		<div
			[autoClose]="true"
			triggers="manual"
			#popover="ngbPopover"
			[ngbPopover]="popContent"
			[toggle]="toggle(popover)"
			[close]="setPopout(false)"
			popoverClass="phase"
			placement="top"
		>
			<div
				style="
					box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
						rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
				"
				class="dropdown show"
			>
				<a
					class="btn dropdown-toggle btn-lg w-100"
					href="#"
					role="button"
					id="dropdownMenuLink"
					data-bs-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					<h5 style="margin: 0px">
						{{ activePhase?.title
						}}<i class="ml-2 fa fa-caret-down" style="opacity: 0.5"></i>
					</h5>
				</a>
				<div
					class="dropdown-menu w-100"
					style="box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px"
					aria-labelledby="dropdownMenuLink"
				>
					<ng-container
						*ngFor="let phase of allPhases; let i = index"
						(click)="changePhase(phase, popover)"
					>
						<a
							class="dropdown-item text-center"
							(click)="changePhase(phase, popover)"
							[class.active-menu-item]="
								activeStudent.assessmentTemplateId == phase.assessmentTemplateId
							"
							>{{ phase?.title }}</a
						>
					</ng-container>
				</div>
			</div>
		</div>
		<div class="mt-2 bg-primary d-flex rounded align-items-center">
			<div class="progress-percentage-wrapper">
				<div class="progress-percentage">{{ loading ? '' : totalScore }}</div>
				<round-progress
					[max]="total"
					[current]="totalScore"
					[color]="'#57A445'"
					[background]="'#555'"
					[radius]="100"
					[stroke]="25"
					[semicircle]="true"
					[rounded]="false"
					[clockwise]="true"
					[responsive]="false"
					[duration]="2000"
					[animation]="'easeInOutQuart'"
					[animationDelay]="0"
				></round-progress>
			</div>
		</div>
	</div>
</div>
<div class="print">
	<h4 style="margin: 0px">
		{{ activeStudent?.fname }} {{ activeStudent?.lname }}
	</h4>
	<div>D.O.B: {{ activeStudent?.dob }}</div>
	<div>{{ activeStudent?.sex }}</div>
	<h5>{{ currentTestSystem.name }}</h5>
</div>
